const componentResolver = (component) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/${component}`);

export { componentResolver };

export default componentResolver;
